import { UserApiModel } from '../../../types/models/user.model';
import { AddDomainToUserApiRequest } from '../../../types/requests/users/add-domain-to-user.request';
import { AddRoleToUserApiRequest } from '../../../types/requests/users/add-role-to-user.request';
import { CreateUserApiRequest } from '../../../types/requests/users/create-user.request';
import { DeleteUserApiRequest } from '../../../types/requests/users/delete-user.request';
import { GetUserApiRequest } from '../../../types/requests/users/get-user.request';
import { RemoveDomainFromUserApiRequest } from '../../../types/requests/users/remove-domain-from-user.request';
import { RemoveRoleFromUserApiRequest } from '../../../types/requests/users/remove-role-from-user.request';
import { SearchUsersApiRequest } from '../../../types/requests/users/search-users.request';
import { UpdateAuthenticatedUserApiRequest } from '../../../types/requests/users/update-authenticated-user.request';
import { UpdateUserApiRequest } from '../../../types/requests/users/update-user.request';
import { GetAuthenticatedUserResponse } from '../../../types/responses/authentication/get-authenticted-user.response';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createUser = (params: CreateUserApiRequest) => client.post<UserApiModel>('/users', params);

export const updateUser = ({ userId, ...params }: UpdateUserApiRequest) =>
  client.patch<UserApiModel>(`/users/${userId}`, params);

export const getUser = <T extends UserApiModel>({ userId, ...params }: GetUserApiRequest) =>
  client.get<T>(`/users/${userId}`, { params });

export const getAuthenticatedUser = () => client.get<GetAuthenticatedUserResponse>(`/users/me`);

export const updateAuthenticatedUser = (params: UpdateAuthenticatedUserApiRequest) =>
  client.patch<GetAuthenticatedUserResponse>(`/users/me`, params);

export const searchUsers = (params: SearchUsersApiRequest) =>
  client.get<CursorPaginatedApiResponse<UserApiModel>>(`/users`, { params });

export const deleteUser = ({ userId }: DeleteUserApiRequest) => client.delete<void>(`/users/${userId}`);

export const addRoleToUser = ({ userId, roleId }: AddRoleToUserApiRequest) =>
  client.post<void>(`/users/${userId}/roles/${roleId}`);

export const removeRoleFromUser = ({ userId, roleId }: RemoveRoleFromUserApiRequest) =>
  client.delete<void>(`/users/${userId}/roles/${roleId}`);

export const addDomainToUser = ({ userId, domainId }: AddDomainToUserApiRequest) =>
  client.post<void>(`/users/${userId}/domains/${domainId}`);

export const removeDomainFromUser = ({ userId, domainId }: RemoveDomainFromUserApiRequest) =>
  client.delete<void>(`/users/${userId}/domains/${domainId}`);
